import {CustomError} from "ts-custom-error";

export class HttpError extends CustomError {

    constructor(public readonly code: number,
                message?: string) {
        super(message);
    }
}